import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  CompanyPlanUpgradeFeatureEnum,
  AccessComponentEnum,
  AccessLevelEnum,
} from 'graphql-common';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import FeatureLockState from '@lib/components/FeatureLockState';
import PageBody from '@lib/layouts/DashboardLayout/PageBody/PageBody';
import PageHeader from '@lib/layouts/DashboardLayout/PageHeader/PageHeader';
import Trans from '@lib/components/Trans/Trans';
import { PlanState } from '@lib/enums/plan';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import DocumentList from '../DocumentList/DocumentList';

export default function DocumentApprovals() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { getUserAccessByCompany, handleOpenPlanModal }: ContextProps =
    useOutletContext();
  const isPlanLocked =
    getUserAccessByCompany(AccessComponentEnum.DocumentationManagement) ===
    AccessLevelEnum.LimitedRead;

  if (isPlanLocked) {
    return (
      <>
        <BreadCrumbs data={getBreadCrumbsDataByKey({ pathname, t })} />
        <PageHeader title={t('approvals')} />
        <PageBody>
          <FeatureLockState
            title={t('unlock-document-approvals')}
            text={<Trans i18nKey="unlock-document-approvals-text" />}
            onUpgrade={() =>
              handleOpenPlanModal(PlanState.Locked, [
                CompanyPlanUpgradeFeatureEnum.Documentation,
              ])
            }
          />
        </PageBody>
      </>
    );
  }

  return <DocumentList isApprovals />;
}
